import 'arrive';

// Velocità in pixel al secondo: costante per tutte le slide
const PX_PER_SEC = 80;
const SPACE_BETWEEN = 30;

function initCarousel(el) {
    const container = el.querySelector('.block-carousel__carousel');
    if (!container || container.dataset.tickerInitialized === 'true') return;
    container.dataset.tickerInitialized = 'true';

    const wrapper = container.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    // Slide originali (non cloni)
    const slides = Array.from(wrapper.querySelectorAll('.swiper-slide:not([aria-hidden])'));
    if (slides.length < 2) return;

    // Duplica le slide per il loop infinito seamless
    slides.forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        wrapper.appendChild(clone);
    });

    // Calcola la durata in base alla larghezza totale delle slide originali
    function applyAnimation() {
        let totalWidth = slides.reduce((sum, slide) => sum + slide.offsetWidth + SPACE_BETWEEN, 0);
        if (!totalWidth) return;

        // Azzera eventuale stile inline lasciato da Swiper
        wrapper.style.transform = '';
        wrapper.style.transition = 'none';

        // Durata = spazio da percorrere / velocità
        wrapper.style.animationDuration = `${totalWidth / PX_PER_SEC}s`;
    }

    // Aspetta il caricamento immagini per avere offsetWidth corretto
    const imgs = Array.from(container.querySelectorAll('img'));
    let pending = imgs.filter(img => !img.complete).length;

    if (pending === 0) {
        requestAnimationFrame(applyAnimation);
    } else {
        const onLoad = () => { if (--pending <= 0) applyAnimation(); };
        imgs.forEach(img => {
            if (!img.complete) {
                img.addEventListener('load',  onLoad, { once: true });
                img.addEventListener('error', onLoad, { once: true });
            }
        });
    }

    // Fallback per immagini già in cache su iOS (nessun evento load)
    setTimeout(applyAnimation, 400);

    // Ricalcola al resize
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(applyAnimation, 150);
    });
}

document.arrive('.block-carousel', { existing: true }, function (el) {
    initCarousel(el);
});

// Fallback: elementi già nel DOM che arrive si è perso
window.addEventListener('load', () => {
    document.querySelectorAll('.block-carousel').forEach(initCarousel);
});
